/* 存储键名 */
const StorageKey = {
    UserAuth: "KEY_USER_AUTH",
    UserAuthInfo: "KEY_USER_AUTH_INFO",
    navList: "NAV_LIST" //菜单
};
// 文件上传类型
const upTypeList = [{
        name: "Individua",
        url: "",
        iconName: "fa-file-text",
        title: "common.data.receivableType.singleInvoice",
        tooltip: "seller.upload.manual.option.singleInvoices.tooltip",
        tip: "seller.upload.manual.option.singleInvoices.tip",
        type: 1,
        num: 0,
        postType: 'SingleInvoice'
    },
    {
        name: "InstallmentContractRate",
        url: "",
        iconName: "fa-list-alt",
        title: "common.data.receivableType.installmentContract",
        tooltip: "seller.upload.manual.option.installmentContract.tooltip",
        tip: "seller.upload.manual.option.installmentContract.tip",
        type: 6,
        num: 60,
        postType: 'InstallmentContractRate'
    },
    {
        name: "CreditMemo",
        url: "",
        iconName: "fa-envelope-open",
        title: "common.data.receivableType.creditMemo",
        tooltip: "seller.upload.manual.option.creditMemo.tooltip",
        tip: "seller.upload.manual.option.creditMemo.tip",
        type: 5,
        num: 50,
        postType: 'CreditMemo'
    },
    {
        name: "Settlement",
        url: "",
        iconName: "fa-list",
        title: "common.data.receivableType.settlementList",
        tooltip: "seller.upload.manual.option.settlementList.tooltip",
        tip: "seller.upload.manual.option.settlementLists.tip",
        type: 2,
        num: 20,
        postType: 'SettlementList'
    },
    {
        name: "Collective",
        url: "",
        iconName: "fa-archive",
        title: "common.data.receivableType.collectiveInvoice",
        tooltip: "seller.upload.manual.option.collectiveInvoice.tooltip",
        tip: "seller.upload.manual.option.collectiveInvoices.tip",
        type: 3,
        num: 10,
        postType: 'CollectiveInvoice'
    },

];

const newStateList = [{
        name: "",
        type: 1,
        iconName: "fa-lock",
        colorName: "inactive_color"
    },
    {
        name: "",
        type: 2,
        iconName: "fa-search-plus",
        colorName: "secondary_color"
    }
];
// 
const IPUList = [
    {
        icon: 'fa fa-clock-o',
        color: "base_color",
        confirmLevel: 0,
    },
    {
        icon: 'fa fa-check-circle-o',
        color: "valid_color",
        confirmLevel: 1
    },
    {
        icon: 'fa fa-clock-o',
        color: "base_color",
        confirmLevel: 2
    },
]

const allCountryList = () => {
        let item = {
            translationKey: '',
            code: ''
        }
        let codeList = [
            'DE', 'CH',
            'FR', 'PL',
            'CZ', 'ES',
            'LU', 'AT',
            'IT', 'NL',
            'NO', 'PK',
            'MK', 'RO',
            'WS', 'RS',
            'SG', 'SK',
            'SI', 'ZA',
            'SE', 'TR',
            'GB', 'US',
            'AG', 'AW',
            'AU', 'BE',
            'BQ', 'CA',
            'HR', 'CW',
            'CY', 'DK',
            'EE', 'GH',
            'GI', 'GR',
            'GG', 'HK',
            'HU', 'IS',
            'IE', 'JE',
            'LV', 'LI',
            'LT', 'MT',
            'MU', 'NZ',
        ]
        let countryList = []
        codeList.forEach(item => {
            let itemData = {
                translationKey: `common.country.${item}`,
                code: item
            }
            countryList.push(itemData)
        })
        return countryList
    }
    // [
    // //     translationKey: "common.country.DE"
    // // code: "DE"
    //     ]
    // NoAuction(-99), // Default value for receivable.current_auction_status
    // New(0), 
    // Public(1),//点了开始 设置的是5分钟后开始
    // Selling(2),
    // Sold(3),
    // Abortive(4),
    // Canceled(5);
const auctionStatus = [{
        status: -99,
        name: ' No Auction',
        color: 'invalid_color',
        key: 'auction.status.noAuction'

    }, {
        status: 0,
        name: 'New',
        color: 'accent_color',
        key: 'auction.status.new'
    },
    {
        status: 1,
        name: 'Public',
        color: 'accent_color',
        key: 'auction.status.StartingSoon'

    },
    {
        status: 2,
        // name: ' In Auction',
        name: 'Selling',
        color: 'accent_color',
        key: 'auction.status.running'


    },
    {
        status: 3,
        name: 'Sold',
        color: 'valid_color',
        key: 'auction.status.Ended',


    },
    {
        status: 4,
        // name: 'Not Sold',
        // Expired
        // name: 'Abortive',
        name: 'Expired',
        color: 'invalid_color',
        key: 'auction.status.Expired',


    },
    {
        status: 5,
        // name: 'Not Sold',
        name: 'Canceled',
        color: 'invalid_color',
        key: 'auction.status.Canceled'
    },
]
const userLevel = [{
        num: 30,
        name: 'User'
    },
    {
        num: 20,
        name: 'Deputy'
    },
    {
        num: 10,
        name: 'Master-User'
    },
]

const ipuStatus = [{
        status: 1,
        name: 'Causal IPU'
    },
    {
        status: 2,
        name: 'Abstract IPU'
    },
]
const discloseList = [{
        disclosed: true,
        translationKey: 'common.disclosed',
        text: 'disclosed',
        value: 1,
    },
    {
        disclosed: false,
        translationKey: 'common.undisclosed',
        text: 'undisclosed',
        value: 0,
    },
]






// Investor Management   table change api
// operation 0  1  2   {ids:[],optration:1}
// 2>1 3>1   operation=0
// 1>3  operation=1
// 2>3  operation=2
const InvestorTableList = [{
        id: 1,
        type: 'whitelisted',
        shuttleType: 'enabled'
    },

    {
        id: 2,
        type: 'unhandled',
        shuttleType: 'unChecked'
    },
    {
        id: 3,
        type: 'blacklisted',
        shuttleType: 'excluded'

    },
]
const industryList = () => {
    return 1
}

const MatchTypeEnum = 'ISNULL' | 'ISNotNULL' | 'EQ' | 'NEQ' | 'LIKE' | 'IN' | 'NIN' | 'LT' | 'LE' | 'GT' | 'GE' | 'MEMBER' | 'NOTMEMBER' | 'EMPTY' | 'NOTEMPTY';
// S(String),
// I(Integer),
// L(Long),
// N(Double),
// D(Date),
// B(Boolean),
// T(Instant),
// C(BigDecimal);
const FieldTypeEnum = 'S' | 'I' | 'L' | 'N' | 'D' | 'B' | 'T' | 'C';
// ISNULL: 为空
// ISNotNULL： 不为空
// EQ： 等于
// NEQ： 不等于
// LIKE ： 字符串匹配
// IN：包含
// NIN： 不包含
// LT：小于
// LE：小于等于
// GT： 大于
// GE： 大于等于
const ShuttleFilterData = {
    country: {
        fieldType: 'S',
        matchType: 'IN'
    },
    industry: {
        fieldType: 'L',
        matchType: 'IN'
    }
}

const enumStatus = {
    auctionStatus,
    StorageKey,
    upTypeList,
    newStateList,
    IPUList,
    userLevel,
    discloseList,
    InvestorTableList,
    industryList,
    allCountryList,
    ipuStatus,
    ShuttleFilterData
};

export default enumStatus;